/**
 * @file HomeHeader.js
 * @description This component displays a header image for the home page.
 */
import React from 'react';
import './HomeHeader.css';

/**
 * @component
 * @description This component displays a header image for the home page.
 * @returns {JSX.Element} The rendered component.
 */
const HomeHeader = () => {
  return (
    <section className="home-header">
      <div className="header-content">
        <h1 className="header-headline">ENGINEERED FOR BRAND OBSESSION</h1>
      </div>
    </section>
  );
};

export default HomeHeader;
